import React, { Fragment } from "react";
import { Button, Card, CardContent, Dialog } from "@mui/material";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { ImageInPageEditorV2 } from "cms/images/image-inpage-editor-v2";

const SlideshowImageSettingsDialog = (props) => {
    const {
        visible,
        setVisible,
        image,
        settings,
        onChangeImageWithSettings,
        onRemoveImage,
        setImage,
        setSettings,
    } = props;

    const handleClose = () => {
        setVisible(false);
    };

    const imageEditContext = {
        image,
        settings,
        onChangeImageWithSettings,
        onRemoveImage,
        setImage,
        setSettings,
    };

    return (
        <Fragment>
            <Dialog
                open={visible}
                onClose={handleClose}
                fullWidth={true}
                maxWidth='lg'
                className="simplicity-document-selector-overlay"
            >
                <ImageEditContext.Provider value={imageEditContext}>
                    <Card elevation={0} className='simplicity-image-settings-window'>
                        <CardContent sx={{ flex: "1 0 auto", height: "100%" }}>
                            <Fragment>
                                <div className='simplicity-image-selector-window-title'>
                                    Slideshow Image Settings
                                </div>
                            </Fragment>
                            
                            <div
                                style={{ padding: "24px", }}
                                className='simplicity-image-composer-container'
                            >
                                <ImageInPageEditorV2
                                    image_guid={image?.guid}
                                    settings={settings}
                                    onChangeImageWithSettings={onChangeImageWithSettings}
                                    onRemoveImage={onRemoveImage}
                                />
                            </div>
                      
                        </CardContent>
                    </Card>
                    
                    <div className="simplicity-image-selector-window-footer">
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                    </div>
                
                </ImageEditContext.Provider>
            </Dialog>
        </Fragment>
    );
};

export { SlideshowImageSettingsDialog }; 
